module.exports = __webpack_public_path__ + "static/img/job-description-generator.c609013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/job-description-generator.png
// module id = avnT
// module chunks = 0